const SITE_URL = "https://www.reignitespirit.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "ReigniteSpirit",
  alternateName: "Reignite Spirit",
  url: SITE_URL,

  logo: {
    "@type": "ImageObject",
    "@id": `${SITE_URL}/#logo`,
    url: `${SITE_URL}/logo512.png`,
    contentUrl: `${SITE_URL}/logo512.png`,
    width: 512,
    height: 512,
    caption: "ReigniteSpirit",
  },

  image: {
    "@id": `${SITE_URL}/#logo`,
  },

  description:
    "Career intelligence, career transition analysis, career audit reports and financial runway tools for professionals planning their next career move.",

  sameAs: [
    // Add only genuine active social media profile URLs.
    // Example:
    // "https://www.linkedin.com/company/your-real-company-page"
  ],
};